export enum PaymentStatusEnum {
    PENDING = 'PENDING',
    SUCCESS = 'SUCCESS',
    CANCELLED = 'CANCELLED',
    FAILED = 'FAILED',
}